<template>
    <div>
        <!-- Header -->
        <div class="clearfix row py-2 mb-2 mt-5 no-margin border-bottom">
            <div class="col-sm-6 text-left pl-0">
                <h5 class="mb-0">Compensatory Leave List (Approved)</h5>
            </div>
        </div>

        <!-- Table -->
        <div class="row justify-content-center no-margin">
            <div class="col-sm-12 px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table dataTable">
                        <thead>
                            <tr class="table-head">
                                <td>Employee</td>
                                <td>Job Position</td>
                                <td>Department</td>
                              <td>Leave Shift</td>
                              <td>Used Attendance</td>
                                <td>Reason</td>
                                <td class="text-right" v-if="ce">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(leave, index) in leaves" :key="index">
                                <td>
                                    <div class="img-holder">
                                        <img
                                            :src="`/avatar/${leave.company_id}/${leave.employee_pic}`"
                                            class="img-fluid img-thumbnail employee-avatar mr-2" />
                                    </div>
                                    <div class="name-holder">
                                        {{ leave.employee_name }}<br />
                                        <span class="txt-alt">{{ leave.employee_code }}</span>
                                    </div>
                                </td>
                                <td>{{ leave.jobposition_name }}</td>
                                <td>{{ leave.department_name }}</td>
                              <td v-b-tooltip.hover.top="leave.leave_assignment.shift.start + '-' + leave.leave_assignment.shift.end + 'Date: ' + leave.leave_assignment.date">
                                <div class="assignment-card d-flex align-items-center">
                                  <div class="shift-dot mr-3" style="height: 20px; width: 20px; border-radius: 50%;" :style="{ background: leave.leave_assignment.shift.color }"></div>
                                  <div>
                                    <div class="font-weight-bold">{{ leave.leave_assignment.shift.name }}</div>
                                  </div>
                                </div>
                              </td>
                              <td v-b-tooltip.hover.top="leave.attendance_assignment.shift.start + '-' + leave.attendance_assignment.shift.end + '\nDate: ' + leave.attendance_assignment.date">
                                <div class="assignment-card d-flex align-items-center">
                                  <div class="shift-dot mr-3" style="height: 20px; width: 20px; border-radius: 50%;" :style="{ background: leave.attendance_assignment.shift.color }"></div>
                                  <div>
                                    <div class="font-weight-bold">{{ leave.attendance_assignment.shift.name }}</div>
                                  </div>
                                </div>
                              </td>
                              <td>{{ leave.reason }}</td>
                                <td class="position-relative text-right" v-if="ce">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu w-200"
                                        aria-labelledby="actionDropdown">
                                        <b-button-group class="mr-0">
                                            <b-button class="mr-3 rounded edit-btn" title="Edit Work Location"
                                                @click="updateLeave(leave.id, 2)">
                                                <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="leaves.length === 0" class="list-no-data">No records found.</div>
                </b-overlay>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            leaves: [],
            showoverlay_list: false,
            ce: true,
            employee_id: 0,
        };
    },
    created: function () {
        this.getLeaves();
    },
    methods: {
        getLeaves() {
            this.showoverlay_list = true;
            axios
                .get(this.$api_url + '/leave-attendance/company-compensatory-leave-list?status=1')
                .then((response) => {
                    this.leaves = response.data;
                    this.showoverlay_list = false;
                })
                .catch((err) => {
                    console.error('Error fetching leaves:', err);
                    this.leaves = [];
                    this.showoverlay_list = false;
                });
        },
        updateLeave(id, status) {
            this.showoverlay = true;

            let formData = new FormData();
            formData.append('id', id);
            formData.append('status', status);

            axios.post(this.$api_url + '/leave-attendance/compensatory-leave-update', formData)
                .then(response => {
                    this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });

                    this.getLeaves();
                    this.$emit('childToParent');
                    this.$emit('updateList', { status: status });
                })
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
        }
    },
};
</script>

